import { NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH } from '../RouteConstants';

export const natTopinLaunchRouteSeoInfo = {
  title: 'NIAT | Take NAT',
  description: 'Continue to your NAT exam. Secure access for NIAT applicants.',
  path: NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH
};
